module.exports = __webpack_public_path__ + "static/media/burger-icon.8bb57983.svg";